export const QR_LOGO_IMAGE_SIZE = 48;

export const QR_CONFIG = {
  DISPLAY_SIZE: 200,

  LOGO: {
    SIZE: 48,
    PADDING: 8,
    BACKGROUND_COLOR: "#FFFFFF",
    get TOTAL_SIZE() {
      return this.SIZE + this.PADDING * 2;
    },
  },

  STYLE: {
    DEFAULT_COLOR: "#000000",
    BACKGROUND_COLOR: "transparent",
    ERROR_CORRECTION_LEVEL: "H" as const,
  },

  DOWNLOAD: {
    PNG: {
      SCALE_FACTOR: 3,
      QUALITY: 1.0,
      IMAGE_SMOOTHING: false,
    },
    SVG: {
      LOGO_SIZE_RATIO: 0.24,
    },
    DISCLAIMER: {
      TEXT: "CGI is not responsible for misuse or incorrect use of the QR code.",
      FONT_FAMILY: "'Source Sans Pro', Arial, sans-serif",
      FONT_SIZE_PX: 7,
      COLOR: "#666666",
      MARGIN_TOP_PX: 5,
    },
  },
} as const;

export const validateLogoSize = (qrSize: number): boolean => {
  const logoRatio = QR_CONFIG.LOGO.TOTAL_SIZE / qrSize;
  return logoRatio <= 0.3;
};

export const calculateLogoCenter = (
  containerSize: number,
  logoSize: number = QR_CONFIG.LOGO.TOTAL_SIZE
): { x: number; y: number } => {
  const position = (containerSize - logoSize) / 2;
  return { x: position, y: position };
};
